import { render } from "./DashboardComponent.vue?vue&type=template&id=f0829ee4&scoped=true"
import script from "./DashboardComponent.vue?vue&type=script&lang=js"
export * from "./DashboardComponent.vue?vue&type=script&lang=js"

import "@/styles/DashboardComponent.css?vue&type=style&index=0&id=f0829ee4&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0829ee4"]])

export default __exports__